import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface UnsavedChangesFormModalProps {
  isOpen: boolean
  onClose: () => void
  onSaveAndExit: () => void
  onExitWithoutSaving: () => void
  isSaving?: boolean
}

const UnsavedChangesFormModal = ({
  isOpen,
  onClose,
  onSaveAndExit,
  onExitWithoutSaving,
  isSaving = false,
}: UnsavedChangesFormModalProps) => {
  return (
    <OneModal isOpen={isOpen} onClose={onClose}>
      <OneModal.Header title={i18n.t('trainings.surveys.create.unsaved_changes_modal.title')} />
      <OneModal.Content withPadding>
        {i18n.t('trainings.surveys.create.unsaved_changes_modal.description')}
      </OneModal.Content>
      <OneModal.Footer>
        <Box flexDirection="row" gap="s12" justifyContent="flexEnd" width="full">
          <F0Button
            onClick={onExitWithoutSaving}
            label={i18n.t('trainings.surveys.create.unsaved_changes_modal.quit_without_saving')}
            variant="outline"
            disabled={isSaving}
          />
          <F0Button
            onClick={onSaveAndExit}
            label={i18n.t('trainings.surveys.create.unsaved_changes_modal.save_and_quit')}
            variant="default"
            loading={isSaving}
          />
        </Box>
      </OneModal.Footer>
    </OneModal>
  )
}

export default UnsavedChangesFormModal
